(() => {
  const body = document.body;

  if (body.classList.contains('flatsons-catalog-mode')) {
    document.addEventListener('submit', (event) => {
      const form = event.target.closest('form[action*="/cart/add"]');
      if (form) event.preventDefault();
    });
    document.addEventListener('click', (event) => {
      const orderControl = event.target.closest('[name="add"], .shopify-payment-button, a[href="/cart"], a[href^="/cart?"], a[href^="/checkout"], button[name="checkout"]');
      if (orderControl) event.preventDefault();
    });
  }

  const header = document.querySelector('#site-header');
  const syncHeader = () => header && header.classList.toggle('sticky', window.scrollY > 40);
  syncHeader();
  window.addEventListener('scroll', syncHeader, { passive: true });

  const menuButton = document.querySelector('[data-flatsons-menu]');
  const navigation = document.querySelector('#main-nav');
  const closeMenu = () => {
    navigation?.classList.remove('open');
    body.classList.remove('menu-open');
    menuButton?.setAttribute('aria-expanded', 'false');
  };
  menuButton?.addEventListener('click', () => {
    const open = navigation?.classList.toggle('open') ?? false;
    body.classList.toggle('menu-open', open);
    menuButton.setAttribute('aria-expanded', String(open));
  });
  navigation?.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
  window.addEventListener('keydown', (event) => event.key === 'Escape' && closeMenu());

  let revealObserver;
  const initReveals = (root = document) => {
    const reveals = root.querySelectorAll('.reveal');
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches && !Shopify.designMode) {
      revealObserver ||= new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObserver.unobserve(entry.target);
        }
      });
      }, { threshold: 0.12 });
      reveals.forEach((element) => revealObserver.observe(element));
    } else {
      reveals.forEach((element) => element.classList.add('visible'));
    }
  };
  initReveals();

  document.querySelectorAll('[data-tilt]').forEach((tilt) => {
    if (!window.matchMedia('(pointer: fine)').matches) return;
    tilt.addEventListener('mousemove', (event) => {
      const box = tilt.getBoundingClientRect();
      const x = (event.clientX - box.left) / box.width - 0.5;
      const y = (event.clientY - box.top) / box.height - 0.5;
      const image = tilt.querySelector('img');
      if (image) image.style.transform = `translate(${x * 12}px, ${y * 12}px) rotateY(${x * 5}deg) rotateX(${-y * 5}deg)`;
    });
    tilt.addEventListener('mouseleave', () => {
      const image = tilt.querySelector('img');
      if (image) image.style.transform = '';
    });
  });

  const applyCatalogFilters = (catalog) => {
    if (!catalog) return;
    const activeFilter = catalog.querySelector('[data-product-filter].active')?.dataset.productFilter || 'all';
    const searchInput = catalog.querySelector('[data-catalog-search]');
    const query = searchInput?.value.trim().toLowerCase() || '';
    let visibleCount = 0;

    catalog.querySelectorAll('[data-categories]').forEach((card) => {
      const categories = (card.dataset.categories || '').split(/\s+/).filter(Boolean);
      const categoryMatch = activeFilter === 'all' || categories.includes(activeFilter);
      const searchMatch = query === '' || (card.dataset.catalogSearchText || card.textContent || '').toLowerCase().includes(query);
      const visible = categoryMatch && searchMatch;
      card.hidden = !visible;
      card.classList.toggle('hidden', !visible);
      if (visible) visibleCount += 1;
    });

    const count = catalog.querySelector('[data-catalog-count]');
    if (count) {
      const label = visibleCount === 1 ? count.dataset.singular : count.dataset.plural;
      count.textContent = `${visibleCount} ${label}`;
    }
    const clear = catalog.querySelector('[data-catalog-clear]');
    if (clear) clear.hidden = query === '';
    const empty = catalog.querySelector('[data-catalog-empty]');
    if (empty) empty.hidden = visibleCount !== 0;
  };

  const resetCatalog = (catalog) => {
    if (!catalog) return;
    const input = catalog.querySelector('[data-catalog-search]');
    if (input) input.value = '';
    catalog.querySelectorAll('[data-product-filter]').forEach((item) => {
      const active = item.dataset.productFilter === 'all';
      item.classList.toggle('active', active);
      item.setAttribute('aria-pressed', String(active));
    });
    if (window.location.hash) window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
    applyCatalogFilters(catalog);
    input?.focus();
  };

  document.addEventListener('click', (event) => {
    const filterButton = event.target.closest('[data-product-filter]');
    if (filterButton) {
      const catalog = filterButton.closest('[data-flatsons-catalog]');
      catalog?.querySelectorAll('[data-product-filter]').forEach((item) => item.classList.remove('active'));
      catalog?.querySelectorAll('[data-product-filter]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
      filterButton.classList.add('active');
      filterButton.setAttribute('aria-pressed', 'true');
      const value = filterButton.dataset.productFilter;
      applyCatalogFilters(catalog);
      if (['effects', 'amplifiers', 'wireless', 'accessories', 'new-arrivals'].includes(value)) {
        window.history.replaceState(null, '', `#${value}`);
      } else if (window.location.hash) {
        window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
      }
      return;
    }

    const catalogClear = event.target.closest('[data-catalog-clear]');
    if (catalogClear) {
      const catalog = catalogClear.closest('[data-flatsons-catalog]');
      const input = catalog?.querySelector('[data-catalog-search]');
      if (input) input.value = '';
      applyCatalogFilters(catalog);
      input?.focus();
      return;
    }

    const catalogReset = event.target.closest('[data-catalog-reset]');
    if (catalogReset) {
      resetCatalog(catalogReset.closest('[data-flatsons-catalog]'));
      return;
    }

    const galleryButton = event.target.closest('[data-gallery-src]');
    if (galleryButton) {
      const gallery = galleryButton.closest('[data-product-gallery]');
      const main = gallery?.querySelector('[data-gallery-main]');
      if (main) {
        main.src = galleryButton.dataset.gallerySrc;
        main.alt = galleryButton.dataset.galleryAlt || main.alt;
      }
      gallery?.querySelectorAll('[data-gallery-src]').forEach((item) => item.classList.remove('active'));
      galleryButton.classList.add('active');
      return;
    }

    const faqButton = event.target.closest('.faq-question');
    if (faqButton) {
      const item = faqButton.closest('.faq-item');
      const open = item?.classList.toggle('open') ?? false;
      faqButton.setAttribute('aria-expanded', String(open));
      const mark = faqButton.querySelector('[data-faq-mark]');
      if (mark) mark.textContent = open ? '−' : '+';
    }
  });

  document.addEventListener('input', (event) => {
    const catalogSearch = event.target.closest('[data-catalog-search]');
    if (catalogSearch) {
      applyCatalogFilters(catalogSearch.closest('[data-flatsons-catalog]'));
      return;
    }
    const supportSearch = event.target.closest('[data-support-search]');
    if (!supportSearch) return;
    const query = supportSearch.value.trim().toLowerCase();
    document.querySelectorAll('[data-resource]').forEach((card) => {
      card.classList.toggle('hidden', !card.textContent.toLowerCase().includes(query));
    });
  });

  document.querySelectorAll('[data-year]').forEach((item) => {
    item.textContent = String(new Date().getFullYear());
  });

  const initialProductFilter = window.location.hash.slice(1);
  document.querySelectorAll('[data-flatsons-catalog]').forEach((catalog) => {
    if (['effects', 'amplifiers', 'wireless', 'accessories', 'new-arrivals'].includes(initialProductFilter)) {
      catalog.querySelector(`[data-product-filter="${initialProductFilter}"]`)?.click();
    } else {
      applyCatalogFilters(catalog);
    }
  });

  document.addEventListener('shopify:section:load', (event) => initReveals(event.target));
})();
